import { FieldControl } from '@signature-it/ngx-generic/enums';
import { FormField } from './field';

export class StarRatingField extends FormField {

	checkedColor: string;
	uncheckedColor: string;
	size: string;
	totalStars: number;

	constructor(options: {} = {}) {
		super(options);

		this.checkedColor = options['checkedColor'] || 'gold';
		this.uncheckedColor = options['uncheckedColor'] || 'gray';
		this.size = options['size'] || '12px;';
		this.totalStars = options['totalStars'] || 5;

	}
}
